<template>
    <div class="a-modal">
        <div class="popup__header">
            <span class="title title--sm popup__title" v-if="$route.params.message">{{ $lang('user.purchases.popup.title') }}</span>
            <span class="title title--sm popup__title" v-else-if="$route.params.type == 2">{{ $lang('user.purchases.popup.title2') }}</span>
            <span class="title title--sm popup__title" v-else>{{ $lang('user.purchases.popup.title3') }}</span>
        </div>
        <form class="form" @submit.prevent="submit">
            <div class="popup__content">
                <div class="form__item form__item--inline">
                    <div class="a-modal__inner">
                        <span class="form__label">{{ $lang('user.purchases.popup.label') }}</span>
                        <el-popover v-model="errors.page_id.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.page_id.message">
                            <el-select dusk="page" filterable class="a-modal"
                                       id="page_id"
                                       v-model="form.page_id" required
                                       slot="reference"
                                       :class="{ 'add__error': errors.page_id.isError }"
                                       :placeholder="$lang('user.purchases.popup.select')"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       @focus="clearErrors">
                                <el-option v-for="item in pages"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </div>
                </div>
                <div class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('user.purchases.popup.label2') }}</span>
                    <el-popover v-model="errors.email.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.email.message">
                        <el-input
                            id="email"
                            slot="reference"
                            :class="{ 'add__error': errors.email.isError }"
                            @focus="clearErrors"
                            placeholder="primer@primer.ru"
                            class="input input--big"
                            v-model="form.email"
                        />
                    </el-popover>
                </div>
                <div class="form__item a-modal__big">
                    <span class="form__label">{{ $lang('user.purchases.popup.label3') }}</span>
                    <el-popover v-model="errors.phone.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.phone.message">
                        <input-phone
                            id="phone"
                            slot="reference"
                            :class="{ 'add__error': errors.phone.isError }"
                            @focus="clearErrors"
                            class="input input--big"
                            v-model="form.phone"
                        />
                    </el-popover>
                </div>
            </div>
            <div class="popup__footer">
                <button v-if="$route.params.message" class="btn btn--middle btn--main-bg">{{ $lang('user.purchases.popup.button') }}</button>

                <div v-else>
                  <button v-if="$route.params.type == 2" dusk="buy-button" class="btn btn--middle btn--main-bg">{{ $lang('user.purchases.popup.button2') }}</button>

                  <router-link
                      v-else
                      dusk="buy-button"
                      :to="{
                          name: 'pay-service-delivery',
                          params: {
                              id: form.page_id,
                              propProductName: $lang('user.purchases.popup.productNameTable'),
                              propProductPrice: $route.params.price,
                              propPaymentType: paymentTypes.table
                          }
                      }"
                      class="btn btn--middle btn--main-bg"
                  >
                    <span>{{ $lang('user.purchases.popup.button2') }}</span>
                  </router-link>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import mixin from '../../../mixins/errors';
    import validator from '../../../mixins/validator';
    import InputPhone from "../../../components/InputPhone";
    import Vue from "vue";

    export default {
        name: "popup",
        mixins: [mixin, validator],
        components: {InputPhone},
        data: () => ({
            form: {
                page_id: null,
                email: null,
                phone: null
            },
            pages: [],
            errors: {
                page_id: {
                    isError: false,
                    message: ''
                },
                email: {
                    isError: false,
                    message: ''
                },
                phone: {
                    isError: false,
                    message: ''
                },
            },
            rules: {
                page_id: [
                    {required: true, message: Vue.prototype.$lang('user.purchases.popup.rule')},
                ],
                email: [
                    {required: true, message: Vue.prototype.$lang('user.purchases.popup.rule2')},
                ],
                phone: [
                    {required: true, message: Vue.prototype.$lang('user.purchases.popup.rule3')},
                ],
            },
            paymentTypes: window.laravel.paymentTypes,
        }),
        created() {
            this.getUserPages().then((response) => {
                this.pages = response.data;
            });

            this.form.email = (this.user.email) ? this.user.email : null;
            this.form.phone = (this.user.phone) ? this.user.phone : null;
        },
        computed: {
            ...mapState('cabinet', [
                'individualPages',
                'familyPages',
            ]),
            ...mapState('auth', [
                'user',
            ]),
        },
        methods: {
            ...mapActions('cabinet', [
                'getUserPages',
                'sendQrcodeStone'
            ]),
            submit() {
                this.validate(() => {
                    this.$route.params.message
                        ? this.message()
                        : this.pay()
                }, {...this.form});
            },
            pay() {
                const params = new URLSearchParams({
                    page_id: this.form.page_id,
                    payment_type: this.$route.params.type,
                    price: this.$route.params.price,
                    email: this.form.email,
                    phone: this.form.phone,
                    copyright: this.$route.params.copyright,
                    locale: window.laravel.locale
                });

                if(this.$route.params.type == 2) {
                    this.$dataLayer.push({'event': 'redirectToPayProduct', 'title': 'Подготовка описания'});
                } else {
                    this.$dataLayer.push({'event': 'redirectToPayProduct', 'title': 'Табличка с QR-кодом'});
                }

                window.location.href = window.laravel.prefix + `/payment?${params.toString()}`;
            },
            message() {
                this.$loading(Vue.prototype.$optionsLoading);
                
                this.sendQrcodeStone(this.form)
                    .then(() => {
                        this.$dataLayer.push({'event': 'sendForm', 'title': 'Нанесение QR кода на памятник'});

                        window.location.href = "/cabinet/pages?success=" + Vue.prototype.$lang('user.purchases.popup.success');
                    })
                    .catch((error) => {
                        this.$appNotify.error(error.response.data.errors);
                    })
                    .finally(() => {
                        this.$loading({}).close();
                    })
            }
        }
    }
</script>
